export const canViewPolo = (user) =>
  ['visitor', 'editor', 'admin'].includes(user?.permission)

export const canEditData = (user) =>
  ['editor', 'admin'].includes(user?.permission)

export const isAdmin = (user) => user?.permission === 'admin'
